// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".QQPlotTooltip__tooltip__1b_7Y{padding:.5rem;width:auto}", "",{"version":3,"sources":["webpack://./shared/src/plots/components/ScatterPlots/QQPlot/components/QQPlotTooltip/QQPlotTooltip.css"],"names":[],"mappings":"AAAA,+BAEE,aAAe,CADf,UAEF","sourcesContent":[".tooltip {\n  width: auto;\n  padding: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltip": "QQPlotTooltip__tooltip__1b_7Y"
};
export default ___CSS_LOADER_EXPORT___;
